<!-- app/javascript/dashboard/routes/dashboard/bulkmessage/components/modals/FullTextModal.vue -->

<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center"
    style="
      background-color: rgba(0, 0, 0, 0.04);
      backdrop-filter: blur(4px);
      min-height: 100vh;
      width: 100vw;
      margin: 0;
      top: 0;
      left: 0;
    "
  >
    <div
      class="relative max-h-full overflow-auto bg-n-alpha-3 shadow-md modal-container rtl:text-right skip-context-menu rounded-xl max-w-2xl w-full mx-auto"
    >
      <div
        class="flex justify-between items-center px-6 py-4 border-b-2 border-n-slate-4 dark:border-n-slate-7"
      >
        <h3 class="text-lg font-semibold text-n-slate-12">
          {{ title }}
        </h3>
        <button
          class="text-n-slate-11 hover:text-n-slate-12"
          @click="closeModal"
        >
          <i class="i-lucide-x text-xl" />
        </button>
      </div>
      <div class="px-6 py-4">
        <div
          class="overflow-auto max-h-96 border border-n-slate-3 dark:border-n-slate-7 rounded-lg p-4 bg-n-slate-1 dark:bg-n-slate-3"
        >
          <p class="whitespace-pre-wrap text-n-slate-12">{{ content }}</p>
        </div>
      </div>
      <div
        class="flex justify-end px-6 py-4 border-t-2 border-n-slate-4 dark:border-n-slate-7"
      >
        <Button
          label="Fechar"
          variant="outline"
          color="slate"
          @click="closeModal"
        />
      </div>
    </div>
  </div>
</template>
